import {
  AgCartesianAxisOptions,
  AgCartesianSeriesOptions,
  AgChartOptions,
} from 'ag-charts-enterprise';
import { AgCharts } from 'ag-charts-react';
import { TFunction, useTranslation } from 'translations/hooks';
import { getAgChartLocale } from 'translations/locale';

import { ProgressHistoryGraphPoint } from 'business/dashboard/types';
import { formatDateToWeekDayAndDay } from 'technical/time-utils/format-date-to-day-and-month';
import { colorPrimary } from 'ui/theme/colors';

type ProgressHistoryGraphProps = {
  progressHistoryGraphData: ProgressHistoryGraphPoint[];
};

const tooltipRenderer = (params: any, t: TFunction) => {
  return {
    data: [
      {
        label: '',
        value: t('productionAndPerformance.ringPerDay.graph.tooltip.ring', {
          count: parseInt(params.datum[params.yKey]),
        }),
      },
    ],
  };
};

const progressHistoryGraphSeriesOptions = (t: TFunction) =>
  [
    {
      type: 'bar',
      xKey: 'date',
      yKey: 'count',
      tooltip: { renderer: (params) => tooltipRenderer(params, t) },
      fill: colorPrimary,
    },
  ] satisfies AgCartesianSeriesOptions[];

const progressHistoryGraphAxesOptions = () => {
  return [
    {
      type: 'category',
      position: 'bottom',
      label: {
        formatter: ({ value }) => formatDateToWeekDayAndDay(value),
      },
    },
    {
      type: 'number',
      position: 'left',
      nice: false,
      interval: {
        step: 1,
      },
    },
  ] satisfies AgCartesianAxisOptions[];
};

export function ProgressHistoryGraph({
  progressHistoryGraphData,
}: ProgressHistoryGraphProps) {
  const { t, language } = useTranslation();

  const chartOptions = {
    data: progressHistoryGraphData,
    axes: progressHistoryGraphAxesOptions(),
    series: progressHistoryGraphSeriesOptions(t),
    locale: {
      localeText: getAgChartLocale(language),
    },
  } satisfies AgChartOptions;

  return <AgCharts options={chartOptions} />;
}
